"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitBinaryWriteImpulse = void 0;
var InitBinaryWriteImpulse = /** @class */ (function () {
    function InitBinaryWriteImpulse(uri, override) {
        this.uri = uri;
        this.override = override;
    }
    return InitBinaryWriteImpulse;
}());
exports.InitBinaryWriteImpulse = InitBinaryWriteImpulse;
//# sourceMappingURL=InitBinaryWriteImpulse.js.map